import axios from "../helpers/axios";

export default {
  namespaced: true,

  state: {
    DocenteData: [],
    NivelesDocenteData: [],
    PeriodosData: [],
    GradosDocenteData: [],
    SeccionDocenteData: [],
    AreasDocenteData: [],
    CursosDocenteData: [],  
  },
  getters: {   
    getDocenteData:(state)=>{
      return state.DocenteData;
    },
    getNivelesDocenteData:(state)=>{
      return state.NivelesDocenteData;
    },      
    getPeriodosActual:(state)=>{
      const fechaActual = new Date();
      return state.PeriodosData.filter(item =>
        new Date(item.fecha_inicio) <= fechaActual && fechaActual <= new Date(item.fecha_cierre)
      );
    },
    getGradosDocenteData:(state)=>{
      return state.GradosDocenteData;
    },    
    getSeccionDocenteData:(state)=>{
      return state.SeccionDocenteData;
    },
    getAreasDocenteData:(state)=>{
      return state.AreasDocenteData;
    },
    getCursosDocenteData:(state)=>{
      return state.CursosDocenteData;
    },

  },
  mutations: {  
    setDocenteData(state, payload) {
      state.DocenteData = payload.DocenteData;
    },    
    setNivelesDocenteData(state, payload) {
      state.NivelesDocenteData = payload.NivelesDocenteData;
    },
    setPeriodosData(state, payload) {
      state.PeriodosData = payload.PeriodosData;
    },    
    setGradosDocenteData(state, payload) {
      state.GradosDocenteData = payload.GradosDocenteData;
    },    
    setSeccionDocenteData(state, payload) {
      state.SeccionDocenteData = payload.SeccionDocenteData;
    },
    setAreasDocenteData(state, payload) {
      state.AreasDocenteData = payload.AreasDocenteData;
    },
    setCursosDocenteData(state, payload) {
      state.CursosDocenteData = payload.CursosDocenteData;
    },
    setResetFiltros(state) {
      state.NivelesDocenteData = [];
      state.GradosDocenteData = [];
      state.AreasDocenteData = [];
      state.CursosDocenteData = [];
    },

  },
  actions: {
    /**_______________________________
    |  MÉTODO OBTENER DATOS DOCENTE */
    async obtenerDocenteData(context,id_usuario) {
      try {
        const response = await axios.get(`/sistema/integral/getUsuarioPersonal/${id_usuario}`);
        context.commit("setDocenteData", {
          DocenteData: response.data,
        });
      } catch (error) {
        console.log(error);
      }
    },
    /**______________________________________
    |  MÉTODO OBTENER NIVELES - POR DOCENTE*/
    async obtenerNivelesDocente(context, datosNiv){

      const {id_colegio, id_ano_lectivo, id_docente} = datosNiv

        try {
            const response = await axios.get(`/sistema/integral/getNivelDoc/${id_colegio}/${id_ano_lectivo}/${id_docente}`);
            context.commit("setNivelesDocenteData", {
              NivelesDocenteData: response.data,
            });

        } catch (error) {
            console.log(error);
        }
    },
    /**__________________________
    |  MÉTODO OBTENER PERIODOS */
    async obtenerPeriodo(context, datosPer) {
      try {
          const response = await axios.post(`/sistema/integral/getPeriodo/`, {
              filter: datosPer,
          });
          context.commit("setPeriodosData", {
            PeriodosData: response.data,
          });

      } catch (error) {
          console.log(error);
      }
    },
    /**_____________________________________
    |  MÉTODO OBTENER GRADOS - POR DOCENTE*/
    async obtenerGradoDocente(context, datosGra) {
        try {
            let response = await axios.post(`/sistema/integral/getGradoDoc/`, {
                filter: datosGra,
            });
            context.commit("setGradosDocenteData", {
              GradosDocenteData: response.data,
            });
        } catch (error) {
            console.log(error);
        }
    },
    /**______________________________________
    |  MÉTODO OBTENER SECCION - POR DOCENTE*/
    async obtenerSeccionDocente(context,datosSec) {
      // id_colegio, id_docente, id_grado
        try {

            let response = await axios.post(`/sistema/integral/getSeccionDoc/`, { filter: datosSec })
            context.commit("setSeccionDocenteData", {
              SeccionDocenteData: response.data,
            });

        } catch (error) {
            console.log(error)
        }
    },
    /**_____________________________________
    |  MÉTODO OBTENER GRADOS - POR DOCENTE*/
    async obtenerAreaDocente(context, datosAr) {
        try {
            let response = await axios.post(`/sistema/integral/getAreaDoc/`, {
                filter: datosAr,
            });
            context.commit("setAreasDocenteData", {
              AreasDocenteData: response.data,
            });
        } catch (error) {
            console.log(error);
        }
    },
    /**_____________________________________
    |  MÉTODO OBTENER CURSOS - POR DOCENTE*/
    async obtenerCursoDocente(context, datosCur) {
        try {
            let response = await axios.post(`/sistema/integral/getCursoDoc/`, {
                filter: datosCur,
            });
            context.commit("setCursosDocenteData", {
              CursosDocenteData: response.data,
            });
        } catch (error) {
            console.log(error);
        }
    },

  }, 
};
